import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';

const IconWrapper = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.label`
  display: inline-block;
  position: relative;
  width: ${rem(16)};
  height: ${rem(16)};
  cursor: pointer;
  margin-right: ${rem(9)};

  input[type='checkbox'] {
    cursor: pointer;
    margin: 0;
    padding: 0;
    opacity: 0;

    &:disabled {
      cursor: not-allowed;
    }

    & ~ ${IconWrapper} {
      border-radius: ${({ theme }) => theme.borderRadius};
      transition: background 0.2s, border 0.2s;
      background-color: #fff;
      svg {
        position: relative;
        top: ${rem(1)};
        transform: scale(0);
        transition: transform 0.2s ease-out;
      }
    }

    &:checked ~ ${IconWrapper} {
      svg {
        transform: scale(1);
      }
    }
  }
`;

const Checkbox = (props, context) => {
  return (
    <Wrapper className={props.className}>
      <input {...props} type="checkbox" id={props.id || context.id} />
      <IconWrapper>
        <Icon name="checked" color="#2F2F2F" size="s"/>
      </IconWrapper>
    </Wrapper>
  );
};

Checkbox.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
};
Checkbox.defaultProps = {
  className: null,
  id: null,
};

Checkbox.contextTypes = {
  id: PropTypes.string,
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js